import events from './events'
import { Mindbox } from '@front-box/plugins/mindbox'
import sharedMindboxEvents from '@front-box/assets/analyticEvents/sharedMindboxEvents'

/* global isGbHost, amoId, priceInfo, landingInfo */

const COURSE_VIEW_DELAY = 3000
const mindboxPriceInfo = typeof priceInfo !== 'undefined' ? priceInfo : {}

const logger = {
  log: (message) => {
    window.Sentry?.captureMessage(message)
  }
}

export const mindboxInit = async () => {
  if (isGbHost) {
    return
  }

  const mindbox = new Mindbox({
    endpointId: 'skillbox.skillboxWebsite',
    events: {
      ...sharedMindboxEvents,
      ...events
    },
    logger
  })

  window.$mindbox = mindbox
  await mindbox.init()

  setTimeout(() => {
    window.$mindbox?.push('courseView', {
      amoId,
      discountedPrice: mindboxPriceInfo.discountedPrice,
      fullPrice: mindboxPriceInfo.fullPrice,
      installmentDuration: mindboxPriceInfo.installmentDuration,
      monthlyPrice: mindboxPriceInfo.monthlyPayment,
      directionName: landingInfo.direction_name,
      directionId: landingInfo.direction_id
    })
  }, COURSE_VIEW_DELAY)
}
